import { put, call, takeLatest } from 'redux-saga/effects'

import { DEPARTMENT_PARAM } from 'Constants'

import {
  getTags as getDepartmentsApi,
  createTag as createDepartmentApi,
  deleteTag as deleteDepartmentApi,
} from 'Service/Api'

import * as DepartmentTypes from 'Redux/Types/DepartmentTypes'
import * as DepartmentActions from 'Redux/Actions/DepartmentActions'

function* getDepartments() {
  try {
    const { data } = yield call(getDepartmentsApi, DEPARTMENT_PARAM)
    yield put(DepartmentActions.getDepartmentsSucceeded(data))
  } catch (ex) {
    yield put(DepartmentActions.getDepartmentsFailed(ex))
  }
}

function* createDepartment({ payload }) {
  const { searchTerm, resolve, reject } = payload
  const params = {
    value: searchTerm,
    type: { name: DEPARTMENT_PARAM },
  }
  try {
    const { data } = yield call(createDepartmentApi, params)
    yield put(DepartmentActions.addDepartmentSucceeded(data))
    if (resolve) {
      resolve(data)
    }
  } catch (errors) {
    yield put(DepartmentActions.addDepartmentFailed(errors))
    if (reject) {
      reject(errors)
    }
  }
}

function* deleteDepartment({ payload }) {
  try {
    yield call(deleteDepartmentApi, payload)
    yield put(DepartmentActions.deleteDepartmentSucceeded(payload))
  } catch (errors) {
    yield put(DepartmentActions.deleteDepartmentFailed(errors))
  }
}

export default function* ExpenseCategorySaga() {
  yield takeLatest(DepartmentTypes.GET_DEPARTMENTS, getDepartments)
  yield takeLatest(DepartmentTypes.ADD_DEPARTMENT, createDepartment)
  yield takeLatest(DepartmentTypes.DELETE_DEPARTMENT, deleteDepartment)
}
